import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth, API } from "../App";
import axios from "axios";
import { toast } from "sonner";
import { NestIcon } from "../components/NestIcon";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in React StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        toast.error("Authentication failed");
        navigate("/login");
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        // Exchange session_id for token
        const response = await axios.post(`${API}/auth/session`, {
          session_id: sessionId
        });

        const { token, user } = response.data;
        login(token, user);
        
        // Clear URL fragment
        window.history.replaceState(null, "", window.location.pathname);
        
        toast.success(`Welcome${user.full_name ? `, ${user.full_name}` : ""}!`);
        navigate("/dashboard", { replace: true });
      } catch (error) {
        console.error("Auth error:", error);
        toast.error("Authentication failed. Please try again.");
        navigate("/login");
      }
    };

    processAuth();
  }, [navigate, login]);

  return (
    <div className="min-h-screen bg-secondary flex flex-col items-center justify-center">
      <div className="bg-primary/10 p-4 rounded-full mb-6">
        <NestIcon className="h-12 w-12 text-primary" />
      </div>
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mb-4"></div>
      <p className="text-muted-foreground">Completing sign in...</p>
    </div>
  );
}
